/* eslint-disable no-await-in-loop */
import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router';
import _ from 'lodash';
import * as moment from 'moment';

import { UserPerms, execute } from 'store/configureStore';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import UserSelector from 'components/Base/UserSelector';
import OrderTable from './Sidebar/OrderTable';

import AnnotationsEditor from './Content/AnnotationsEditor';
import AnnotationsList from './Content/AnnotationsList';
import HtmlContent from '../HtmlContent';
import TextEditor from './Content/TextEditor';

import { getLetter } from 'sagas/letters';
import * as sagaAnnotations from 'sagas/annotations';
import * as sagaLetters from 'sagas/lettersNew';

import { removeLetter } from 'actions/letters';
import { postAnnotations, removeAnnotations } from 'actions/annotations';
import { removeGazetters, postGazetters } from 'actions/gazetters';
import { addVesselOrder, removeLastVesselOrder, updateVesselOrderUser } from 'actions/vessels/orders';
import { postRequestVessel } from 'actions/vessels/request';
import { addNotification } from 'actions/notifications/notifications';

import Attachments from '../Attachments';

import styles from 'styles';

import * as actionTypes from 'constants/ActionTypes';

import ErrorBoundary from './ErrorBoundary';
// import Trainings from '../Gazetter/Trainings';
import helpers from '../../../../helpers';

import { saveRequestsDataCreated } from 'sagas/orders';
import FailedToSent from '../../common/FailedToSent';
import api from 'services';
import ToSpamButton from '../../common/ToSpamButton';

class LetterVessel extends React.Component {
    constructor(props) {
        super(props);

        if (localStorage.getItem(`settings-order-vessel${props.objUser.user._id}`)) {
            this.initialState = JSON.parse(localStorage.getItem(`settings-order-vessel${props.objUser.user._id}`));
        } else {
            this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem(`settings-order-vessel${props.objUser.user._id}`, JSON.stringify(this.initialState));
        }

        this.state = {
            ...this.initialState,
            textLetter: '',
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: false,
            clientVessel: undefined,
            openedAttachmentsDialog: false,

            selectedServer: 'mailparse.net',
            failedToSentOpen: false,
            isFormChanged: false,
            vesselOrdersDuplicates: [],
        };

        this.addOrderTable = this.addOrderTable.bind(this);
        this.sendRequestVessel = this.sendRequestVessel.bind(this);
        this.sendRequestVesselFromSent = this.sendRequestVesselFromSent.bind(this);
        this.removeOrderTable = this.removeOrderTable.bind(this);
        this.changeAnnotationsServer = this.changeAnnotationsServer.bind(this);
        this.changeClarifiedServer = this.changeClarifiedServer.bind(this);
        this.clearOrderTable = this.clearOrderTable.bind(this);
        this.updatePostGazetters = this.updatePostGazetters.bind(this);
        this.getLetterData = this.getLetterData.bind(this);

        this.handleClientChange = this.handleClientChange.bind(this);
        this.saveRequestsDataCreated = this.saveRequestsDataCreated.bind(this);
    }

    async getLetterData(textEdit) {
        try {
            const { data: letter } = await execute(getLetter, this.props.routeParams.id, 'vessel');
            letter.gazettersArr = [];
            letter.type = 'vessel';
            letter.fromVesselOrders = true;

            if (textEdit) {
                letter.text = textEdit;
            }
            letter.fromVesselOrders = true;
            const annotationsResponse = await execute(
                sagaAnnotations.postAnnotations, 
                letter.text, 
                letter.type, 
                this.state.annotationsServer, 
                { 
                    emailId: letter._id,
                    subject: letter.subject,
                    date: moment(letter.date).format('DD-MM-YYYY'),
                },
            );

            if (annotationsResponse) {
                letter.gazettersArr = annotationsResponse.data.annotations;
                if (annotationsResponse.data.newclarified) {
                    letter.newclarified = annotationsResponse.data.newclarified;
                }
            }
            
            await execute(sagaLetters.updateLetter, _.omit(letter, 'gazettersArr'), 'vessel', this.state.clarifiedServer);

            this.setState({
                vesselOrdersDuplicates: _.cloneDeep(this.props.vesselOrders.items),
            });
        } catch (error) {
            addNotification({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Error',
                    message: error.errors.messages[0],
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 10,
                },
            });
        }
    }

    changeAnnotationsServer(e, i, value) {
        this.initialState = {
            annotationsServer: value,
            clarifiedServer: this.state.clarifiedServer,
        };

        localStorage.setItem(`settings-order-vessel${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(); });
    }

    changeClarifiedServer(e, i, value) {
        this.initialState = {
            annotationsServer: this.state.annotationsServer,
            clarifiedServer: value,
        };

        localStorage.setItem(`settings-order-vessel${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(); });
    }

    UNSAFE_componentWillMount() {
        const { state } = this.props.location;
        if (state) {
            this.getLetterData(state.modifiedTextLetter);
        } else {
            this.getLetterData();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.vesselOrders, this.state.vesselOrdersDuplicates)) {
            this.setState({ isFormChanged: true });
        } else {
            this.setState({ isFormChanged: false });
        }
    }

    changeServer(e, i, value) {
        this.setState({
            selectedServer: value,
        }, () => {
            this.getLetterData();
        });
    }

    createVesselRequest(vesselOrder, keyVesselOrder, vesselRequests) {
        vesselOrder.open.forEach((openPosition) => {
            vesselRequests.push({
                ...vesselOrder,
                open: {
                    until: openPosition.until,
                    from: openPosition.from,
                    where: openPosition.where,
                },
                user: this.props.user.email,
                keyVesselOrder,
            });
        });

        return vesselRequests;
    }

    createTerms(vesselOrders) {
        vesselOrders.forEach((vesselOrder) => {
            const terms = _.cloneDeep(vesselOrder.terms);

            terms.forEach((term) => {
                if (term.type) {
                    term.value = `${term.type} ${term.value}`;
                }
            });

            vesselOrder.terms = terms;
        });
    }

    async saveRequestsDataCreated(order) {
        try {
            await execute(saveRequestsDataCreated, 'vessel', { ...order, mailId: this.props.letter._id });
        } catch (error) {
            console.error(error);
        }
    }

    async sendRequestVessel() {
        const vesselOrders = _.cloneDeep(this.props.vesselOrders);

        if (!vesselOrders.length) {
            return;
        }

        const vesselRequests = [];

        this.createTerms(vesselOrders);

        vesselOrders.forEach((vesselOrder, keyVesselOrder) => {
            if (!vesselOrder.maintenance) {
                delete vesselOrder.maintenance;
            }

            this.createVesselRequest(vesselOrder, keyVesselOrder, vesselRequests);
        });

        for (let vesselRequestIndex = 0; vesselRequestIndex < vesselRequests.length; vesselRequestIndex++) {
            const vesselRequest = vesselRequests[vesselRequestIndex];

            if (this.state.clientVessel) {
                vesselRequest.realUserEmail = vesselRequest.user;
                vesselRequest.user = this.state.clientVessel;
            }

            this.saveRequestsDataCreated(vesselRequest);

            this.props.postRequestVessel({
                ...vesselRequest,
                mailId: this.props.letter._id,
                eh: this.props.letter.eh,
                clientVessel: this.state.clientVessel,
            });

            await helpers.sleep(1000);
        }

        this.setState({
            isFormChanged: false,
            vesselOrdersDuplicates: _.cloneDeep(this.props.vesselOrders),
        });
    }

    /**
     * @param {import('../../../Letters/common/FailedToSent').FailedTwin} failedTwinLetterData 
     */
    async sendRequestVesselFromSent(failedTwinLetterData) {
        const vesselOrders = _.cloneDeep(this.props.vesselOrders);
        
        if (!vesselOrders.length) {
            return;
        }

        const vesselRequests = [];
        const results = [];

        this.createTerms(vesselOrders);

        vesselOrders.forEach((vesselOrder, keyVesselOrder) => {
            if (!vesselOrder.maintenance) {
                delete vesselOrder.maintenance;
            }

            this.createVesselRequest(vesselOrder, keyVesselOrder, vesselRequests);
        });

        for (let vesselRequestIndex = 0; vesselRequestIndex < vesselRequests.length; vesselRequestIndex++) {
            const vesselRequest = vesselRequests[vesselRequestIndex];

            if (failedTwinLetterData.context.kind === 'broker') {
                vesselRequest.realUserEmail = failedTwinLetterData.realUserEmail;
                vesselRequest.user = failedTwinLetterData.owner.email;
                vesselRequest.mailId = failedTwinLetterData._id;
            }

            const response = await api.postRequestVessel({
                ...vesselRequest,
                mailId: failedTwinLetterData._id,
                eh: failedTwinLetterData.context.kind,
                clientVessel: failedTwinLetterData.owner,
            });

            if (response.status === 200) {
                results.push({
                    ...response.data,
                    status: 'success',
                });
                await api.sendRefNumber(failedTwinLetterData._id, {
                    refNo: response.data.refNo, 
                    requestId: response.data.id || response.data._id,
                });
            } else if (response.status === 409) {
                results.push({
                    status: 'success',
                    ..._.get(response, 'errors[0].messages[1]'),
                });
                await api.sendRefNumber(failedTwinLetterData._id, {
                    refNo: _.get(response, 'errors[0].messages[1]').refNo, 
                    requestId: _.get(response, 'errors[0].messages[1]')._id,
                });
            } else {
                results.push({
                    status: 'error',
                    message: _.get(response, 'errors[0].messages[0]'),
                });
            }

            await helpers.sleep(1000);
        }

        return results;
    }

    removeOrderTable() {
        this.props.removeLastVesselOrder();
    }

    clearOrderTable() {
        this.props.removeLastVesselOrder();
        this.props.addVesselOrder();
    }

    addOrderTable() {
        this.props.addVesselOrder();
    }

    componentWillUnmount() {
        this.props.removeGazetters();
        this.props.removeAnnotations();
        this.props.removeLetter();
    }

    updatePostGazetters(textLetter) {
        this.setState({
            textLetter,
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: true,
        }, async () => {
            await this.props.postGazetters(
                textLetter,
                {
                    emailId: this.props.letter._id,
                    subject: this.props.letter.subject,
                    date: moment(this.props.letter.date).format('DD-MM-YYYY'),
                },
            );
        });
    }

    handleClientChange(e, i, value) {
        this.setState({ clientVessel: value });
    }

    toggleAttachmentsDialog = () => {
        this.setState({
            openedAttachmentsDialog: !this.state.openedAttachmentsDialog,
        });
    }

    toggleFailedToSentOpen = () => {
        this.setState({
            failedToSentOpen: !this.state.failedToSentOpen,
        });
    }

    render() {
        const {
            annotationsServer, clarifiedServer, textLetter, updated, clientVessel, openedAttachmentsDialog,
            failedToSentOpen,
        } = this.state;
        const {
            routeParams, letter, router, vesselOrders, objUser, user, location, 
        } = this.props;
        // from gazetter via react router state
        let modifiedTextLetter;
        let initialTextLetter;

        if (location.state) {
            modifiedTextLetter = location.state.modifiedTextLetter;
            initialTextLetter = location.state.initialTextLetter;
        }

        return (
            <div id='single-letter-cargo' className='single-letter'>
                <div className='content'>
                    <div className='management'>
                        <div className='management-children'>
                            <RaisedButton
                                label='Gazetteer'
                                containerElement={<Link to={`/${routeParams.id}`} />}
                                primary
                                className="btn"
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            />
                            <ErrorBoundary>
                                <HtmlContent
                                    letter={letter}
                                />
                            </ErrorBoundary>

                            <TextEditor 
                                textLetter={modifiedTextLetter || textLetter || letter.text}
                                originalText={initialTextLetter || letter.text}
                                removeGazetters={this.props.removeGazetters}
                                removeAnnotations={this.props.removeAnnotations}
                                getLetterData={this.getLetterData}
                                updatePostGazetters={this.updatePostGazetters}
                            />

                            <Attachments 
                                openedAttachmentsDialog={openedAttachmentsDialog}
                                toggleAttachmentsDialog={this.toggleAttachmentsDialog}
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px -10px' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                className='btn'
                                attachments={letter.attachments}
                            />

                            <RaisedButton 
                                className='btn'
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                label='Size'
                                containerElement={<Link to={`/${routeParams.id}/size/vessel`} />}
                                primary
                            />

                            {
                                UserPerms.isAdmin() ?
                                    <React.Fragment>
                                        <SelectField
                                            floatingLabelText='Annotations server'
                                            className='btn'
                                            value={annotationsServer}
                                            onChange={this.changeAnnotationsServer}
                                            style={{ width: '155px' }}
                                            selected
                                        >
                                            <MenuItem value='mailparse.net' primaryText='mailparse.net' />
                                            <MenuItem value='s4.anotatr.com' primaryText='s4.anotatr.com' />
                                            <MenuItem value='nata.im' primaryText='nata.im' />
                                            <MenuItem value='polza' primaryText='polza' />
                                            <MenuItem value='localhost' primaryText='localhost' />
                                        </SelectField>

                                        <SelectField
                                            floatingLabelText='Clarified server'
                                            className='btn'
                                            value={clarifiedServer}
                                            onChange={this.changeClarifiedServer}
                                            style={{ width: '110px' }}
                                            selected
                                            autoWidth
                                        >
                                            <MenuItem value='standart' primaryText='api' />
                                            <MenuItem value='localhost:7775' primaryText='localhost' />
                                            <MenuItem value='s4.anotatr.com:7777' primaryText='s4.anotatr.com' />
                                        </SelectField>
                                    </React.Fragment>
                                    :
                                    ''
                            }
                            <br />
                            {/* <Trainings letter={letter} /> */}
                            <ToSpamButton
                                letterId={letter._id}
                                onSuccess={() => {
                                    this.getLetterData();
                                }}
                                disabled={letter.type === 'spam'}
                            />
                            <FailedToSent
                                open={failedToSentOpen}
                                failedTwinsList={letter.failedTwinsByTextHash || []}
                                handleToggleDialog={this.toggleFailedToSentOpen}
                                disabled={this.state.isFormChanged}
                                sendRequest={this.sendRequestVesselFromSent}
                            />
                        </div>
                        <div className='subject' style={{ width: '150px' }}>SUBJECT: {letter.subject}</div>
                        <div className='subject'>refNo: {letter.refNo}</div>
                        
                    </div>
                    {
                        updated ?
                            (
                                <ErrorBoundary>
                                    <AnnotationsEditor letterText={textLetter || letter.text} />
                                </ErrorBoundary>
                            )
                            :
                            (
                                <ErrorBoundary>
                                    <AnnotationsEditor letterText={modifiedTextLetter || letter.text} />
                                </ErrorBoundary>
                            )
                    }

                    <ErrorBoundary>
                        <AnnotationsList />
                    </ErrorBoundary>
                </div>
                <div className='sidebar'>
                    <h1>Vessel orders {vesselOrders.length}</h1>

                    <ErrorBoundary>
                        {
                            vesselOrders.map((vesselOrder, key) => (<OrderTable
                                numberOrderTable={key}
                                key={key}
                            />))
                        }
                    </ErrorBoundary>

                    <UserSelector 
                        handleClientChange={this.handleClientChange}
                        client={clientVessel}
                        user={user}
                        letter={letter}
                        errorUser={vesselOrders[0] && vesselOrders[0].validateErrors.find(v => v.field === 'user')}
                        onUserUpdate={this.props.updateVesselOrderUser}
                    />

                    <ul className='controller-orders'>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.addOrderTable} label='Add' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.removeOrderTable} label='Remove' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.clearOrderTable} label='Clear' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.sendRequestVessel} label='Send' />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        objUser: state.user,
        user: state.vesselOrders.user,
        vesselOrders: state.vesselOrders.items,
        isLogged: state.user.isLogged,
        letter: state.letter,
        annotations: state.annotations.items,
        vesselRequestsResults: state.vesselRequests.results,
    }),
    dispatch => bindActionCreators({
        updateVesselOrderUser,
        postAnnotations,
        postGazetters,
        addVesselOrder,
        removeLastVesselOrder,
        postRequestVessel,
        removeGazetters,
        removeAnnotations,
        removeLetter,
    }, dispatch),
)(LetterVessel);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Vessel/Page.jsx